export default function checkIfHeadless() {
  return /[hH]eadless/i.test(window?.navigator?.userAgent) ? 1 : 0;
}
